import React, { useEffect, useRef, useState } from "react"
import { Button } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import * as Yup from "yup"
import { useSubheader } from "../../../../_metronic/layout/index.js"
import { TabsInputComponent } from "../../../../component/index.jsx"
import { RoutesConstants } from "../../../../constants/RoutesConstants.js"
import { FIELD_OFFICER_ROLE_ENUM, ROUTING_STATUS } from "../../../../constants/StringConstant.js"
import {
  clearDetailFo,
  createFo,
  getDetail,
  getListRoleFO,
  updateFo
} from "../../../../redux/actions/FieldOfficerAction.jsx"
import {
  getListFieldManagerByUserLogin,
  getListFieldSupervisorByUserLogin,
  getListRegionalByUserLogin,
  getListRegionalHeadByUserLogin
} from "../../../../redux/actions/MasterDataAction.jsx"
import {
  FORM_NEED,
  getMaximumErrorString,
  getMinimumErrorString,
  getStringErrorMassage
} from "../../../helpers/StringCollection.js"
import { DataFo } from "./step/DataFo.jsx"
import { PreviewFieldOfficer } from "./step/Preview.jsx"
import { loadUserLogin } from "../../../service/userManagementAction.js"
import {
  ILLUSTRATION_CONSTANTS
} from "../../../../constants/ImageConstants.js"
import { toAbsoluteUrl } from "../../../../_metronic/_helpers/index.js"
import { GENERAL } from "../../../../constants/InitTypeConstants.js"

export const FieldOfficerFormWrapper = ({
  history,
  match: {
    params: { id, tab }
  }
}) => {
  const subHeader = useSubheader()
  const dispatch = useDispatch()
  const formRef = useRef()
  const { FieldOfficer, General } = useSelector((state) => state)
  const [stepsTitle, setStepsTitle] = useState(["Data Operational Team"])
  const { t } = useTranslation()
  const [isSubmit] = useState(true)
  const [activeStep, setActiveStep] = useState(0)
  const [successNavigationPath, setSuccessNavigationPath] = useState("")
  const [swalMessage, setSwalMessage] = useState("")
  const [swalIcon, setSwallIcon] = useState("")
  const [role, setRole] = useState(null)
  const [initialData, setInitialData] = useState({
    id: "",
    name: "",
    phone: "",
    email: "",
    avatar: "",
    foProvince: "",
    foPregency: "",
    foDistrict: "",
    foSubDistrict: "",
    foPostalCode: "",
    foAddress: "",
    roleFO: "",
    regional: "",
    regionalHead: "",
    regionalId: loadUserLogin().regional_id,
    subRegional: [],
    base: ""
  })

  const breadcrumbData = [
    {
      pathname:
        FieldOfficer?.detail.role === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_QA
          ? RoutesConstants.FIELD_OFFICER.LIST_FO_QA(ROUTING_STATUS.STATUS_STRING.ACTIVE)
          : (FieldOfficer?.detail.role === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_HARVEST || FieldOfficer?.detail.role === FIELD_OFFICER_ROLE_ENUM.HARVEST_SPV)
            ? RoutesConstants.FIELD_OFFICER.LIST_FO(
              FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_HARVEST
            ) : (FieldOfficer?.detail.role === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_AGRONOMIST || FieldOfficer?.detail.role === FIELD_OFFICER_ROLE_ENUM.DRONE_PILOT_SPV)
              ? RoutesConstants.FIELD_OFFICER.LIST_FO_AGRONOMIS("list-fo")
              : (FieldOfficer?.detail.role === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_QA)
                ? RoutesConstants.FIELD_OFFICER.LIST_FO_QA(ROUTING_STATUS.STATUS_STRING.ACTIVE)
                : RoutesConstants.FIELD_OFFICER.LIST_FO(
                  FieldOfficer?.detail.role ?? FIELD_OFFICER_ROLE_ENUM.REGIONAL_HEAD
                ),
      title:
        FieldOfficer?.detail.role === FIELD_OFFICER_ROLE_ENUM.FIELD_SUPERVISOR
          ? t("sub_header_field_supervisor")
          : FieldOfficer?.detail.role === FIELD_OFFICER_ROLE_ENUM.FIELD_MANAGER
            ? t("sub_header_field_manager")
            : (FieldOfficer?.detail.role === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_HARVEST || FieldOfficer?.detail.role === FIELD_OFFICER_ROLE_ENUM.HARVEST_SPV)
              ? t("sub_header_fo_harvest")
              : (FieldOfficer?.detail.role === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_AGRONOMIST || FieldOfficer?.detail.role === FIELD_OFFICER_ROLE_ENUM.DRONE_PILOT_SPV)
                ? t("sub_header_fo_agronomist")
                : (FieldOfficer?.detail.role === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_QA)
                  ? t("sub_header_fo_qa")
                  : FieldOfficer?.detail.role === FIELD_OFFICER_ROLE_ENUM.REGIONAL_HEAD
                    ? t("sub_header_regional_head")
                    : typeof id !== "undefined"
                      ? t("sub_header_fo")
                      : t("menu_quick_access")
    },

    {
      title:
        typeof id !== "undefined"
          ? t("sub_header_edit_operational_team")
          : t("sub_header_add_ops_team")
    }
  ]

  useEffect(() => {
    if (!id) {
      if (!stepsTitle.includes(t("label_preview"))) {
        stepsTitle.push(t("label_preview"))
        setStepsTitle([...stepsTitle])
      }
    }
    subHeader.setBreadcrumbs(breadcrumbData)
    subHeader.setTitle(
      typeof id !== "undefined"
        ? t("sub_header_edit_operational_team")
        : t("sub_header_add_ops_team")
    )
  }, [id, FieldOfficer, FieldOfficer?.detail.role])

  useEffect(() => {
    if (id) {
      dispatch(getDetail(id))
    }
    return () => {
      dispatch(clearDetailFo())
    }
  }, [id])

  useEffect(() => {
    if (General.isFinishUpdateOrDelete && General.actionInitType !== GENERAL.UPLOAD) {
      completeSubmit(swalMessage, swalIcon, role, successNavigationPath)
    }
  }, [General.isFinishUpdateOrDelete])

  const completeSubmit = (message, icon, role, redirectPath = successNavigationPath) => {
    swal(message, {
      icon: icon
    }).then(() => {
      if (id) {
        tab
          ? history.push(RoutesConstants.FIELD_OFFICER.DETAIL_FO_QA(role, tab, id))
          : history.push(RoutesConstants.FIELD_OFFICER.DETAIL_FO(role, id))
      } else {
        history.push(redirectPath)
      }
    })
  }

  useEffect(() => {
    dispatch(getListRoleFO())
    dispatch(getListRegionalByUserLogin())
    dispatch(getListRegionalHeadByUserLogin())
    dispatch(getListFieldManagerByUserLogin())
    dispatch(getListFieldSupervisorByUserLogin())
    return () => {
      dispatch(clearDetailFo())
      subHeader.setButton(null)
    }
  }, [])

  useEffect(async () => {
    if (isSubmit) {
      if (window.location.href.includes("edit")) {
        subHeader.setButton(
          <Button
            variant="primary"
            onClick={() => {
              if (formRef.current) {
                formRef.current?.handleSubmit()
              }
            }}>
            UPDATE
          </Button>
        )
      }
    }
  }, [isSubmit])

  useEffect(async () => {
    if (!id) {
      subHeader.setButton(
        <Button
          variant="primary"
          disabled={activeStep !== renderComponent().steps.length - 1}
          onClick={() => {
            if (formRef.current) {
              formRef.current?.handleSubmit()
            }
          }}>
          SUBMIT
        </Button>
      )
    } else {
      if (window.location.href.includes("new")) {
        subHeader.setButton(false)
      }
    }
  }, [id, activeStep])

  useEffect(() => {
    const state = FieldOfficer?.detail
    if (state?.account_id && id) {
      const mappedSubRegional = state?.sub_regional_list
        ? (state.sub_regional_list || []).map((item) => item?.id)
        : state?.sub_regional_id
          ? [state.sub_regional_id]
          : []

      setInitialData({
        avatar: state?.url_profile,
        email: state?.email,
        foProvince: state?.province_id,
        foRegency: state?.regency_id,
        foDistrict: state?.district_id,
        foSubDistrict: state?.sub_district_id,
        foPostalCode: state?.postal_code,
        foAddress: state?.address,
        name: state?.name,
        phone: state?.phone_number,
        roleFO: state?.role,
        regional: state?.regional_id,
        fieldSupervisor: state?.field_supervisor_id,
        fieldManager: state.field_manager_id,
        regionalHead: state?.regional_head_id,
        regionalId: loadUserLogin().regional_id,
        subRegional: mappedSubRegional,
        base: state?.base_id,
      })
    }
  }, [FieldOfficer?.detail])

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .min(3, getMinimumErrorString(3))
      .max(100, getMaximumErrorString(100))
      .required(getStringErrorMassage(t("label_name"), FORM_NEED.harusDiIsi)),
    email: Yup.string()
      .email("Invalid Email")
      .required(getStringErrorMassage("Email ", FORM_NEED.harusDiIsi)),
    phone: Yup.string()
      .matches(/^[0-9]+$/, "Harus Angka")
      .min(8, getMinimumErrorString(8))
      .max(15, getMaximumErrorString(15))
      .required(getStringErrorMassage("Phone Number ", FORM_NEED.harusDiIsi)),
    roleFO: Yup.string()
      .required(getStringErrorMassage(t("label_role"), FORM_NEED.harusDiIsi))
      .nullable(),
    regional: Yup.string()
      .transform((value) => (value === null ? "" : value))
      .when("roleFO", {
        is: (roleFO) =>
          roleFO === FIELD_OFFICER_ROLE_ENUM.FIELD_MANAGER ||
          roleFO === FIELD_OFFICER_ROLE_ENUM.REGIONAL_HEAD ||
          roleFO === FIELD_OFFICER_ROLE_ENUM.FIELD_SUPERVISOR ||
          roleFO === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_HARVEST ||
          roleFO === FIELD_OFFICER_ROLE_ENUM.HARVEST_SPV ||
          roleFO === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER,
        then: Yup.string()
          .transform((value) => (value === null ? "" : value))
          .required(getStringErrorMassage(t("label_regional"), FORM_NEED.harusDiIsi)),
        otherwise: Yup.string().nullable()
      }),
    fieldManager: Yup.string().nullable(),
    fieldSupervisor: Yup.string().nullable(),
    regionalHead: Yup.string().nullable(),
    subRegionalByFm: Yup.string().nullable(),
    subRegional: Yup
      .array()
      .when("roleFO", {
        is: (roleFO) =>
          roleFO === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_HARVEST ||
          roleFO === FIELD_OFFICER_ROLE_ENUM.HARVEST_SPV ||
          roleFO === FIELD_OFFICER_ROLE_ENUM.FIELD_MANAGER ||
          roleFO === FIELD_OFFICER_ROLE_ENUM.FIELD_SUPERVISOR ||
          roleFO === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER,
        then: Yup.array()
          .min(1, t("label_input_must_inputted", { input: t("label_sub_regional") }))
          .required(t("label_input_must_inputted", { input: t("label_sub_regional") })),
        otherwise: Yup.array().nullable()
      }),
    foProvince: Yup.string().required(getStringErrorMassage("Provinsi ", FORM_NEED.harusDiIsi)),
    foRegency: Yup.string().required(getStringErrorMassage("Kota ", FORM_NEED.harusDiIsi)),
    foDistrict: Yup.string().required(getStringErrorMassage("Kecamatan ", FORM_NEED.harusDiIsi)),
    foSubDistrict: Yup.string().required(getStringErrorMassage("Kelurahan ", FORM_NEED.harusDiIsi)),
    foPostalCode: Yup.string(),
    foAddress: Yup.string()
      .required(getStringErrorMassage("Alamat ", FORM_NEED.harusDiIsi))
      .max(255, getMaximumErrorString(255)),
    base: Yup.string()
      .when("roleFO", {
        is: (roleFO) =>
          roleFO === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_HARVEST ||
          roleFO === FIELD_OFFICER_ROLE_ENUM.HARVEST_SPV ||
          roleFO === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER,
        then: Yup.string().required(getStringErrorMassage(t("sub_header_base"), FORM_NEED.harusDiIsi)),
        otherwise: Yup.string().nullable()
      })
  })

  const handleSpace = (e) => {
    if (formRef.current.values.name === "" || e.target.selectionStart === 0) {
      e.keyCode === 32 && e.preventDefault()
    }
  }

  const renderComponent = () => {
    const steps = ["Data Operational Team"]
    const stepsDescription = [t("label_user_information"), t("label_review_and_submit")]
    const flow = [<DataFo key={0} isReadOnly={false} onKeyDown={handleSpace} />]

    if (!id) {
      if (!steps.includes(t("label_preview"))) {
        steps.push(t("label_preview"))
        stepsDescription.push("ReviewIndividual & Submit")
        flow.push(<PreviewFieldOfficer />)
      }
    }

    return {
      steps,
      stepsDescription,
      flow
    }
  }

  const onSubmit = async ({ submited, values }) => {
    if (submited) {
      const payload = {
        name: values?.name,
        phone_number: values?.phone,
        email: values?.email,
        province_id: values?.foProvince,
        regency_id: values?.foRegency,
        district_id: values?.foDistrict,
        sub_district_id: values?.foSubDistrict,
        postal_code: values?.foPostalCode,
        full_address: values?.foAddress,
        url_profile: values?.avatar,
        regional_id: values?.regional,
        regional_head_id: values?.regionalHead === "" ? null : values?.regionalHead,
        role: values?.roleFO,
        sub_regional_ids: values?.subRegional ?? [],
        base_id: values?.base
      }
      let sweetAlertMessage = ""
      if (id) {
        payload.field_officer_id = id
        if (payload.role === FIELD_OFFICER_ROLE_ENUM.FIELD_MANAGER) {
          sweetAlertMessage = t("messages_response_edit_field_manager_success")
        } else if (payload.role === FIELD_OFFICER_ROLE_ENUM.REGIONAL_HEAD) {
          sweetAlertMessage = t("messages_response_edit_regional_head_success")
        } else if (payload.role === FIELD_OFFICER_ROLE_ENUM.FIELD_SUPERVISOR) {
          sweetAlertMessage = t("messages_response_edit_field_supervisor_success")
        } else if (payload.role === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_QA) {
          sweetAlertMessage = t("messages_response_edit_fo_qa_success")
        } else if (payload.role === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_AGRONOMIST) {
          sweetAlertMessage = t("messages_response_edit_fo_agronomist_success")
        } else if (payload.role === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER) {
          sweetAlertMessage = t("messages_response_edit_fo_success")
        } else {
          sweetAlertMessage = t("messages_response_edit_ops_team_success")
        }
        setSwalMessage(sweetAlertMessage)
        setSwallIcon(toAbsoluteUrl(ILLUSTRATION_CONSTANTS.SUCCESS_OPS_TEAM_EDIT))
        setRole(values?.roleFO)
        dispatch(updateFo(payload))
      } else {
        switch (values?.roleFO) {
          case FIELD_OFFICER_ROLE_ENUM.FIELD_MANAGER:
            sweetAlertMessage = t("messages_title_add_field_manager_successfully")
            setSuccessNavigationPath(
              RoutesConstants.FIELD_OFFICER.LIST_FO(FIELD_OFFICER_ROLE_ENUM.FIELD_MANAGER)
            )
            break
          case FIELD_OFFICER_ROLE_ENUM.REGIONAL_HEAD:
            sweetAlertMessage = t("messages_title_add_regional_head_successfully")
            setSuccessNavigationPath(
              RoutesConstants.FIELD_OFFICER.LIST_FO(FIELD_OFFICER_ROLE_ENUM.REGIONAL_HEAD)
            )
            break
          case FIELD_OFFICER_ROLE_ENUM.FIELD_SUPERVISOR:
            sweetAlertMessage = t("messages_title_add_field_supervisor_successfully")
            setSuccessNavigationPath(
              RoutesConstants.FIELD_OFFICER.LIST_FO(FIELD_OFFICER_ROLE_ENUM.FIELD_SUPERVISOR)
            )
            break
          case FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER:
            sweetAlertMessage = t("messages_title_add_field_officer_successfully")
            setSuccessNavigationPath(
              RoutesConstants.FIELD_OFFICER.LIST_FO(FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER)
            )
            break
          case FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_HARVEST:
            sweetAlertMessage = t("messages_title_add_field_officer_successfully")
            setSuccessNavigationPath(
              RoutesConstants.FIELD_OFFICER.LIST_FO(FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_HARVEST)
            )
            break
          case FIELD_OFFICER_ROLE_ENUM.HARVEST_SPV:
            sweetAlertMessage = t("messages_title_add_field_officer_successfully")
            setSuccessNavigationPath(
              RoutesConstants.FIELD_OFFICER.LIST_FO(FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_HARVEST)
            )
            break
          case FIELD_OFFICER_ROLE_ENUM.DRONE_PILOT_SPV:
            sweetAlertMessage = t("messages_title_add_field_officer_successfully")
            setSuccessNavigationPath(
              RoutesConstants.FIELD_OFFICER.LIST_FO_AGRONOMIS("list-fo")
            )
            break
          case FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_AGRONOMIST:
            sweetAlertMessage = t("messages_title_add_field_officer_successfully")
            setSuccessNavigationPath(
              RoutesConstants.FIELD_OFFICER.LIST_FO_AGRONOMIS("list-fo")
            )
            break
          default: {
            sweetAlertMessage = t("messages_response_add_ops_team_success")
            setSuccessNavigationPath(
              RoutesConstants.FIELD_OFFICER.LIST_FO(FIELD_OFFICER_ROLE_ENUM.REGIONAL_HEAD)
            )
            break
          }
        }
        setSwalMessage(sweetAlertMessage)
        setSwallIcon(toAbsoluteUrl(ILLUSTRATION_CONSTANTS.SUCCESS_ASSIGN_GENERAL))
        setRole(values?.roleFO)
        dispatch(createFo(payload))
      }
    }
  }

  return (
    <>
      <TabsInputComponent
        isEditTabs={[undefined, null, ""].indexOf(id) < 0}
        steps={renderComponent().steps}
        stepDescription={renderComponent().stepsDescription}
        innerRef={formRef}
        formInitialValues={initialData}
        formId="formFo"
        componentTab={renderComponent().flow}
        validationSchema={[validationSchema]}
        onSubmitForm={onSubmit}
        onChangeStep={(activeStep) => {
          setActiveStep(activeStep)
        }}
      />
    </>
  )
}
